//(function () {
//    'use strict';

//    angular.module("imApp").factory("priceListsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
